import { distinctUntilChanged } from 'rxjs/operators';
import { ChangeDetectionStrategy, Component, signal } from "@angular/core";
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { DialogService } from 'primeng/dynamicdialog';
import * as FlatFacades from "@medsurf/flat-facades";

@Component({
    selector: "medsurf-chapter-slide",
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: "./chapter-slide.component.html",
    styleUrls: ["./chapter-slide.component.scss"],
    standalone: false
})
export class ChapterSlideComponent {
  isSlide = signal(false);
  
  constructor(public nodeSharedFacade: FlatFacades.NodeSharedFacade,
              public dialogService: DialogService) {
    this.nodeSharedFacade.isSlide$.pipe(takeUntilDestroyed(), distinctUntilChanged()).subscribe((isSlide) => {
      this.isSlide.set(isSlide);
      
      // Close All Open Dialogs
      this.dialogService.dialogComponentRefMap.forEach(dialog => {
        dialog.destroy();
      });
    });
  }
}
